/*
    all variables set in .env file are passed to process.env

    the environment in process.env.REACT_APP_ENV is set in package.json by the custom start commend.
*/

const Configuration = {
    cookiename: process.env.REACT_APP_DSGVO_COOKIENAME as string,

    // https://medium.com/@karthitheprogrammer/setup-multiple-environments-development-staging-production-with-react-js-9a2508338b71

    // refer to: https://create-react-app.dev/docs/adding-custom-environment-variables/
    host: process.env.REACT_APP_BACKEND_URL_PRODUCTION as string,
    version: process.env.REACT_APP_VERSION_PRODUCTION as string,
};


//if(process.env.REACT_APP_BACKEND_URL !== undefined) {  // 
//    Configuration.host = process.env.REACT_APP_BACKEND_URL as string;
//    Configuration.version = process.env.REACT_APP_VERSION_DEVELOPMENT as string;
//}
//else {
    if(process.env.REACT_APP_ENV === "development") {
        Configuration.cookiename = process.env.REACT_APP_DSGVO_COOKIENAME as string;

        Configuration.host = process.env.REACT_APP_BACKEND_URL_DEVELOPMENT as string;
        Configuration.version = process.env.REACT_APP_VERSION_DEVELOPMENT as string;
    }

    if(process.env.REACT_APP_ENV === "staging") {
        Configuration.cookiename = process.env.REACT_APP_DSGVO_COOKIENAME as string;

        Configuration.host = process.env.REACT_APP_BACKEND_URL_STAGING as string;
        Configuration.version = process.env.REACT_APP_VERSION_STAGING as string;
    }

    if(process.env.REACT_APP_ENV === "production") {
        Configuration.cookiename = process.env.REACT_APP_DSGVO_COOKIENAME as string;

        Configuration.host = process.env.REACT_APP_BACKEND_URL_PRODUCTION as string;
        Configuration.version = process.env.REACT_APP_VERSION_PRODUCTION as string;
    }

    if(process.env.REACT_APP_ENV === "kubernetes") {
        Configuration.cookiename = process.env.REACT_APP_DSGVO_COOKIENAME as string;

        Configuration.host = process.env.REACT_APP_BACKEND_URL_KUBERNETES as string;
        Configuration.version = process.env.REACT_APP_VERSION_KUBERNETES as string;
    }

    if(process.env.REACT_APP_ENV === "azure") {
        Configuration.cookiename = process.env.REACT_APP_DSGVO_COOKIENAME as string;

        Configuration.host = process.env.REACT_APP_BACKEND_URL_AZURE as string;
        Configuration.version = process.env.REACT_APP_VERSION_AZURE as string;
    }

    if(process.env.REACT_APP_ENV === "production-docker") {
        Configuration.cookiename = process.env.REACT_APP_DSGVO_COOKIENAME as string;

        Configuration.host = process.env.REACT_APP_BACKEND_URL_DOCKER_PRODUCTION as string;
        Configuration.version = process.env.REACT_APP_VERSION_DOCKER_PRODUCTION as string;
    }

    if(process.env.REACT_APP_ENV === "staging-docker") {
        Configuration.cookiename = process.env.REACT_APP_DSGVO_COOKIENAME as string;

        Configuration.host = process.env.REACT_APP_BACKEND_URL_DOCKER_STAGING as string;
        Configuration.version = process.env.REACT_APP_VERSION_DOCKER_STAGING as string;
    }


//}

export default Configuration;
